import { addDays } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { pathOr } from 'ramda';
import React from 'react';

import { useAuth } from '../../app/AuthorizationProvider';
import { GetAgentProductionScheduleComponent, GetScheduleElementsComponent } from '../../graphql/components';
import { LoadingOverlay } from '../LoadingOverlay';
import { MyScheduleWeekly } from './MyScheduleWeekly';

interface MyScheduleWeeklyContainerProps {
  highlightedDate?: number;
  selectedDate: Date;
}

export const MyScheduleWeeklyContainer: React.FC<MyScheduleWeeklyContainerProps> = ({
  highlightedDate,
  selectedDate,
}) => {
  const { userId: agentId, timezone } = useAuth();

  const endDate = addDays(selectedDate, 7);

  const startDateZoned = zonedTimeToUtc(selectedDate, timezone);
  const endDateZoned = zonedTimeToUtc(endDate, timezone);

  return (
    <GetScheduleElementsComponent>
      {(scheduleElementsResult) => (
        <GetAgentProductionScheduleComponent
          variables={{
            agentId,
            timezone,
            startDateTime: startDateZoned.toISOString(),
            endDateTime: endDateZoned.toISOString(),
          }}
          fetchPolicy="network-only"
        >
          {(agentScheduleResult) => {
            const isLoading = agentScheduleResult.loading || scheduleElementsResult.loading;
            const isError = agentScheduleResult.error || scheduleElementsResult.error;
            return (
              <LoadingOverlay loading={isLoading}>
                {isLoading || isError ? null : (
                  <MyScheduleWeekly
                    highlightedDate={highlightedDate}
                    selectedDate={selectedDate}
                    overviewStats={pathOr({}, ['data', 'agentProductionSchedule', 'stats'], agentScheduleResult)}
                    scheduleItems={pathOr(
                      [],
                      ['data', 'agentProductionSchedule', 'scheduleItems'],
                      agentScheduleResult
                    )}
                    scheduleElements={pathOr([], ['data', 'scheduleElements'], scheduleElementsResult)}
                    dailyShifts={pathOr([], ['data', 'agentProductionSchedule', 'dailyShifts'], agentScheduleResult)}
                  />
                )}
              </LoadingOverlay>
            );
          }}
        </GetAgentProductionScheduleComponent>
      )}
    </GetScheduleElementsComponent>
  );
};
